export default __webpack_public_path__ + "static/media/TrydLogo.c7c0c36b.svg";